export function pageCursor(nextAfter: unknown, messages: Array<{ seq: number }> | undefined) {
  const explicit = Number(nextAfter);
  if (Number.isSafeInteger(explicit) && explicit >= 0) return explicit;
  return messages?.at(-1)?.seq ?? 0;
}

export function reconnectCursor(catchupAfter: number | null, latestSeenSequence: number) {
  return catchupAfter ?? latestSeenSequence;
}

export function reconnectDelay(attempt: number, now: number, retryNotBefore: number) {
  const exponential = Math.min(10_000, 500 * 2 ** Math.max(0, attempt));
  return Math.max(exponential, Math.max(0, retryNotBefore - now));
}
